import createAuth0Client from '@auth0/auth0-spa-js';
import constants from '../../constants';

let auth0Client = null;

export default async function getClient() {
  if (!auth0Client) {
    auth0Client = await createAuth0Client({
      ...constants.AUTH0_CONFIG,
      redirect_uri: `${window.location.origin}/v2/auth-resolve`,
      useRefreshTokens: true,
      cacheLocation: 'localstorage'
    });
  }

  return auth0Client;
}



// WEBPACK FOOTER //
// ./src/utils/auth0/client.js